import { z } from "zod";
import { SocialGender } from "../../types/models/social.models.types";

export const zManageFiltersFormAdmin = z.object({
  filters: z.object({
    followers: z
      .object({
        min: z.coerce
          .number()
          .min(1, { message: "Please enter minimum followers" })
          .optional(),
        max: z.coerce
          .number()
          .min(1, { message: "Please enter maximum followers" })
          .optional(),
      })
      .optional(),
    gender: z.array(z.nativeEnum(SocialGender)).optional(),
    genre: z
      .array(
        z.object({
          id: z.string(),
          title: z.string(),
          emoji: z.string(),
        })
      )
      .optional(),
  }),
});

export type IzManageFiltersFormAdmin = z.infer<typeof zManageFiltersFormAdmin>;
